import { getSearchModelsQueryKey } from '#pplx/frontend/ask-models/hooks/utilities/getSearchModelConfigQuery.js';
import { streamEvents } from '#pplx/frontend/stream/events.js';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
export const useRefreshModelsOnBudgetNotice = () => {
    const queryClient = useQueryClient();
    const refreshedNotices = useRef(new Set());
    useEffect(() => {
        const seen = refreshedNotices.current;
        seen.clear();
        return streamEvents.on('progress', ({ message }) => {
            const notice = message.upsell_information;
            if (notice?.name !== 'quota_exhausted_using_credits' ||
                !message.backend_uuid ||
                !notice.upsell_uuid) {
                return;
            }
            const key = JSON.stringify([message.backend_uuid, notice.upsell_uuid]);
            if (seen.has(key))
                return;
            seen.add(key);
            const filters = { queryKey: getSearchModelsQueryKey(), exact: true };
            // Invalidation alone can reuse an initial fetch that started before the notice.
            void queryClient.cancelQueries(filters, { silent: true });
            void queryClient.invalidateQueries(filters);
        });
    }, [queryClient]);
};
//# sourceMappingURL=useRefreshModelsOnBudgetNotice.js.map